(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mimsy-hyper-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mimsy-product-rail')) {
  customElements.define('mimsy-product-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.track = this.querySelector('[data-product-track]');
      this.controls = this.querySelector('[data-product-controls]');
      if (!this.track || !this.controls) return;
      this.cards = [...this.track.querySelectorAll('.mh-selection-card')];
      this.previous = this.querySelector('[data-product-prev]');
      this.next = this.querySelector('[data-product-next]');
      this.position = this.querySelector('[data-product-position]');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || this.controls.hidden) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, options);
      window.addEventListener('resize', () => this.update(), options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      }
      this.classList.add('is-ready');
      this.update();
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = max < 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const step = this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 1;
      this.index = max > 2 && this.next.disabled
        ? this.cards.length - 1
        : Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / Math.max(1, step))));
      const label = String(this.index + 1);
      if (this.position.textContent !== label) this.position.textContent = label;
    }

    move(direction) {
      this.goTo(Math.min(this.cards.length - 1, Math.max(0, this.index + direction)));
    }

    goTo(index) {
      const left = this.cards[index].offsetLeft - this.cards[0].offsetLeft;
      this.track.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.observer?.disconnect();
      this.listeners = null;
      this.classList.remove('is-ready');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimsy-hyper-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mimsy-catalog-rail')) {
  customElements.define('mimsy-catalog-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.track = this.querySelector('[data-mh-catalog-track]');
      this.controls = this.querySelector('[data-mh-catalog-controls]');
      if (!this.track || !this.controls) return;
      this.cards = [...this.track.querySelectorAll('[data-mh-catalog-card]')];
      this.previous = this.querySelector('[data-mh-catalog-prev]');
      this.next = this.querySelector('[data-mh-catalog-next]');
      this.position = this.querySelector('[data-mh-catalog-position]');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || this.controls.hidden) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, options);
      window.addEventListener('resize', () => this.scheduleUpdate(), options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
      }
      this.classList.add('is-ready');
      this.update();
    }

    scheduleUpdate() {
      if (this.updateFrame) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.update();
      });
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const overflowing = max > 2;
      this.controls.hidden = !overflowing;
      this.classList.toggle('is-overflowing', overflowing);
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const start = this.cards[0].offsetLeft;
      const position = Math.max(0, this.track.scrollLeft);
      this.index = 0;
      let nearest = Infinity;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - start - position);
        if (distance < nearest) {
          nearest = distance;
          this.index = index;
        }
      });
      if (overflowing && this.next.disabled) this.index = this.cards.length - 1;
      const label = String(this.index + 1);
      if (this.position.textContent !== label) this.position.textContent = label;
    }

    move(direction) {
      this.goTo(Math.min(this.cards.length - 1, Math.max(0, this.index + direction)));
    }

    goTo(index) {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const left = Math.min(max, Math.max(0, this.cards[index].offsetLeft - this.cards[0].offsetLeft));
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left, behavior });
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.observer?.disconnect();
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.updateFrame = null;
      this.listeners = null;
      this.classList.remove('is-ready', 'is-overflowing');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
